import React, { Component } from "react";
import { Link } from "react-router-dom";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import Footer from "../../../components/common/Footer";

export default class VLSITeaching extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner
          title="Electronics Engineering (VLSI Design & Technology)"
          image="banners/department-cse.jpg"
        />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="section-title with-desc text-left clearfix">
                  <div className="title-header">
                    <h4 className="title">Learning Resources</h4>
                  </div>
                </div>
                <div className="ttm-service-description">
                  <p>
                    Wide arrays of learning materials are provided to students
                    in advance for each course to catalyze their learning
                    ability. These resources include syllabus, course materials,
                    and links to digital aids. Click here to access learning
                    resources.
                  </p>
                  <Link
                    className="ttm-btn"
                    style={{
                      fontSize: "1.15rem",
                      paddingTop: "1rem",
                      color: "#00a76a",
                    }}
                    to={
                      process.env.PUBLIC_URL +
                      `/teaching-learning-material/vlsi`
                    }
                  >
                    Click Here for Learning Resources
                  </Link>
                </div>
                <div className="section-title with-desc text-left clearfix paddingtop-2">
                  <div className="title-header">
                    <h4 className="title">Teaching - Learning</h4>
                  </div>
                </div>
                <div className="ttm-service-description">
                  <h6 className="paddingtop-1">Initiatives in Teaching:</h6>
                  <br />
                  <div
                    className="ttm-service-description"
                    style={{ paddingBottom: "1rem" }}
                  >
                    <p style={{ fontSize: "1.1rem" }}>
                      The department fosters innovative, student-centric, and
                      outcome-based teaching practices to enhance the overall
                      academic experience. Key initiatives include
                    </p>
                  </div>

                  <ul className="ttm-list ttm-list-style-icon">
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      Outcome-Based Education (OBE) : Curriculum delivery and
                      lesson plans are aligned with Course Outcomes (COs),
                      Program Outcomes (POs), and Program Specific Outcomes
                      (PSOs), ensuring structured learning progression.
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      Innovative Pedagogies : Adoption of modern pedagogical
                      techniques like flipped classrooms, project-based
                      learning, case studies, role-plays, and gamification to
                      engage students actively
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      ICT-Enabled Teaching : Faculty members utilize digital
                      tools like Google Meet, Zoom, Kahoot, Padlet, and
                      Microsoft Teams to make lectures interactive and
                      accessible.
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      Blended Learning: Integration of online content (e.g.,
                      NPTEL/SWAYAM videos) into classroom teaching to offer
                      flexibility and deeper engagement.
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      Faculty Development Programs (FDPs) : Regular FDPs are
                      conducted to train faculty on emerging teaching
                      methodologies, NEP 2020 guidelines, and the use of
                      technology in classrooms.
                    </li>
                  </ul>
                </div>
                <div className="ttm-service-description">
                  <h6 className="paddingtop-1">Learning Initiatives:</h6>
                  <br />
                  <div
                    className="ttm-service-description"
                    style={{ paddingBottom: "1rem" }}
                  >
                    <p style={{ fontSize: "1.1rem" }}>
                      To cultivate self-directed and collaborative learning, the
                      institution has adopted the following strategies
                    </p>
                  </div>
                  <ul className="ttm-list ttm-list-style-icon">
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      Student Mentoring System : Regular mentoring sessions are
                      conducted for academic and personal guidance.
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      Interdisciplinary Projects : Students are motivated to
                      take up real-world projects involving multi-domain
                      knowledge
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      Skill Development Activities : Participation in
                      hackathons, coding challenges, technical competitions, and
                      internships is promoted through institutional support.
                    </li>
                    <li>
                      <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content" />
                      Clubs and Centers of Excellence (CoEs) : Technical and
                      non-technical clubs under the guidance of faculty
                      coordinators provide platforms for experiential learning
                      and innovation.
                    </li>
                  </ul>
                </div>
                <div className="ttm-service-description">
                  <h6 className="paddingtop-1">Initiatives in Evaluation:</h6>
                  <br />
                  <div
                    className="ttm-service-description"
                    style={{ paddingBottom: "1rem" }}
                  >
                    <p style={{ fontSize: "1.1rem" }}>
                      A transparent and outcome-oriented evaluation system is in
                      place to assess learning at multiple levels
                    </p>
                  </div>
                  <ul className="ttm-list ttm-list-style-icon">
                    <li>
                      <i className="fa fa-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Continuous Internal Evaluation (CIE) : A well-structured
                        CIE system includes tests, assignments, quizzes,
                        seminars, and mini-projects that contribute to formative
                        assessment.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Rubric-Based Assessment : Evaluation of presentations,
                        lab work, and projects is done using well-defined
                        rubrics to ensure consistency and fairness.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Feedback Mechanism : Student feedback on teaching and
                        evaluation methods is collected regularly and analyzed
                        for continuous improvement.
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Bloom’s Taxonomy-Based Question Design : Faculty are
                        trained to frame questions targeting various cognitive
                        levels for balanced assessment
                      </span>
                    </li>
                    <li>
                      <i className="fa fa-circle ttm-textcolor-skincolor" />
                      <span className="ttm-list-li-content">
                        Result Analysis and Remedial Classes : Post-exam
                        performance analysis is conducted, and students needing
                        academic support are offered remedial classes.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="vlsi" />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
